import React from 'react';
import {
  LoadingNav,
  LoadingImageWithSpinner,
  LoadingHeader,
  LoadingIconLink,
  LoadingDescription,
  LoadingCard,
} from './LoadingComponents';

const LoadingSummaryView = ({ step }) => {
  const Cards = () => (
    <>
      <LoadingCard type="option-card" />
      <LoadingCard type="option-card" />
    </>
  );
  return (
    <>
      <LoadingNav />
      <div className="summary__content-container">
        <div className="summary__images-container summary__images-container--loading">
          <LoadingImageWithSpinner className="loading-image--summary-view" />
          <LoadingImageWithSpinner className="loading-image--summary-view" />
        </div>
        <div className="summary__content-container--inner summary__content-inner-container--loading">
          <LoadingHeader className="loading-header--summary-view" />
          <div className="summary__links">
            <LoadingIconLink className="summary__save-link" />
            <LoadingIconLink />
          </div>

          <LoadingHeader className="loading-header--summary-view" />

          <div className="math-box__line standard-features-total">
            <LoadingDescription className="loading-description--short" />
            <LoadingDescription className="loading-description--price" />
          </div>
          <div className="math-box__option-summary">
            <LoadingDescription className="loading-description--long" />
            <LoadingDescription className="loading-description--long" />
          </div>
          <div className="math-box__option-summary">
            <div className="math-box__line">
              <LoadingDescription className="loading-description--short" />
              <LoadingDescription className="loading-description--price" />
            </div>
            <div className="math-box__option-grid">
              <Cards />
            </div>
          </div>
          <div className="math-box__line">
            <LoadingDescription className="loading-description--short" />
            <LoadingDescription className="loading-description--price" />
          </div>
          <div className="math-box__line math-box-net-price">
            <LoadingDescription className="loading-description--short" />
            <LoadingDescription className="loading-description--price" />
          </div>
        </div>
        <div className="summary__next-steps--container">
          <div className="summary__next-steps">
            <LoadingHeader />
            <LoadingHeader className="loading-header--summary-next-step" />
          </div>
          <div className="summary__chat">
            <LoadingDescription className="loading-description--short" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingSummaryView;
